import { PRODUCT_TYPE_FURNITURE, PRODUCT_TYPE_WALLART } from 'models/tracking/constants'
import * as RenderItemTypes from 'constants/renderItemTypes'
import { ProductData } from 'models/furniture'

interface ProductTrackingInfo {
    ProductTitle: string
    ProductId: number
    ProductType: string
    LocalItemNumber: string
}
export const getProductTrackingInfo = (product: ProductData): ProductTrackingInfo => {
    const { name, id, renderType, localItemNumber } = product
    const isArtItem = renderType === RenderItemTypes.ART_ITEM

    return {
        ProductTitle: name,
        ProductId: id,
        ProductType: isArtItem ? PRODUCT_TYPE_WALLART : PRODUCT_TYPE_FURNITURE,
        LocalItemNumber: localItemNumber,
    }
}
